import { render } from "./info.vue?vue&type=template&id=5ae667ec"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"

import "./info.vue?vue&type=style&index=0&id=5ae667ec&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__